var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"text"},[_vm._v("欢迎登录晟诺系统")]),_c('div',{staticClass:"base-submit-btn",staticStyle:{"margin-top":"60px"},on:{"click":_vm.getWechatCode}},[_vm._v("微信一键登录")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-bg"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/shengnuo.png")}})])
}]

export { render, staticRenderFns }